export const SubDirectory = "";

export const SMSAlert = {
  "title": "Confirm Phone",
  "label": "You have been sent an SMS Code. Please type the code in below to continue.",
  "icon": "info"
};

export const EmailAlert = {
  "title": "Confirm Email",
  "label": "You have been emailed a Confirmation Code. Please type the code in below to continue.",
  "icon": "info"
};

export const AppTitle = "WOW Cloud Network";

export const DefaultReferralCode = "70000";

export const CustomPackageID = "ed00261a-87f6-4744-8915-e2d4f40b1111";
export const APPCOOKIE = "wowcloudnetwork";
export const APPADMINCOOKIE = "wowcloudnetworkadmin";
export const APPPACKAGECOOKIE = "wowcloudnetworkpackage";

export const spinnerContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflowY:'hidden',
  overflowX:'hidden',
};

export const lockNotes = {
  notValid: "Dispute is not valid",
  disputedMultiple: "Disputed Multiple Payments",
  other: "Other",
};